import Alert from '@/components/Alert'
import StorageConfig from '../config/StorageConfig'

export default class ErrorService extends Error {
  constructor(error) {
    super(error)
    this.error = error.response
  }

  showError() {
    const statusToken = this.error.data.message
    const icon = this.error.status === 500 ? 'error' : 'warning'
    const title =
      this.error.status === 500
        ? this.error.data.error
        : this.error.status === 401
        ? this.error.data.message
        : 'Terjadi Kesalahan'
    const text =
      this.error.status === 500
        ? this.error.data.message
        : this.error.status === 401
        ? this.error.data.message
        : 'Silahkan coba lagi'

    Alert.error(
      () => {
        if (this.error.status === 401 || this.error.status === 500) {
          location.reload()
          StorageConfig.clearSession()
        } else {
          location.reload()
        }
      },
      icon,
      title,
      text,
    )
    // StorageConfig.clearSession()
    // location.reload()
  }
}
